import { useApolloQuery } from '@/gql/apolloWrapper';

import {
  useGetTrainingRecommendationsQuery,
  CoreRecommendation,
  RecommendationStatus,
} from '@/gql/generated';
import { ref, computed } from '@nuxtjs/composition-api';

let init;

const recommendations = ref<CoreRecommendation[]>([]);

const pendingRecommendations = computed(
  () =>
    recommendations.value?.filter(
      (r) => r.status === RecommendationStatus.Pending
    ) || []
);

const acceptedRecommendations = computed(
  () =>
    recommendations.value?.filter(
      (r) => r.status === RecommendationStatus.Accepted
    ) || []
);

const rejectedRecommendations = computed(
  () =>
    recommendations.value?.filter(
      (r) => r.status === RecommendationStatus.Declined
    ) || []
);

const acceptedOrPendingRecommendations = computed(() => [
  ...pendingRecommendations.value,
  ...acceptedRecommendations.value,
]);

const setupHook = () => {
  init = true;

  // Get training recommendations here.
  const { onResult, onError, loading } = useApolloQuery(
    useGetTrainingRecommendationsQuery,
    { data: {} },
    { data: recommendations },
    {
      placeholderPick: ({ myTrainingRecommendations: res }) =>
        (res || []) as CoreRecommendation[],
    }
  );

  return {
    onResult,
    onError,
    loading,
  };
};

const refresh = () => {
  init = false;
  setupHook();
};

const useTrainingRecommendations = () => {
  if (!init) {
    setupHook();
  }

  return {
    recommendations,
    pendingRecommendations,
    acceptedRecommendations,
    rejectedRecommendations,
    acceptedOrPendingRecommendations,
    refresh,
  };
};

export default useTrainingRecommendations;
